import stitchWith from '../stitchWith'

const stitchFields = stitchWith((fieldProps) => fieldProps, ['fieldPath'])

export default stitchFields
